export default {
    langzh: "简体中文",
    langen: "အင်္ဂလိပ်ဘာသာစကား",
    i18n: "မြန်မာ",
    today: "ဒီနေ့",
    yesterday: "မနေ့က",
    tomorrow: "မနက်ဖြန်",
    last7Days: "လွန်ခဲ့သော ခုနှစ်ရက်",
    nearly1month: "တစ်လနီးပါး",
    nearly3months: "သုံးလနီးပါး",
    next7Days: "နောက် ၇ ရက်",
    nextMonth: "နောက်တစ်လ",
    next3Months: "နောက်တစ်လ",
    year: "တစ်နှစ်",
    month: "လ",
    day: "နေ့"
}